import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { updateUserPassword } from "@shared/features/auth/utils/updateUserPassword";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  currentEmail: string;
};

export function useUpdatePasswordMutation({
  onSuccess,
  schema,
  currentEmail,
}: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return updateUserPassword({
        email: currentEmail,
        oldPassword: data.currentPassword,
        newPassword: data.password,
      });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: async (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useUpdatePasswordMutation;
